import _ from 'lodash'

// Settings Types
// public
export const SettingsModuleName = 'settings'
export const Settings = {
  mutations: {
    setAccount: SettingsModuleName + '/setAccount',
    setSuppliers: SettingsModuleName + '/setSuppliers',
    setAllSuppliers: SettingsModuleName + '/setAllSuppliers',
    setManufacturerSuppliers: SettingsModuleName + '/setManufacturerSuppliers',
    setOpenCloseNewSupplierDialog: SettingsModuleName + '/setOpenCloseNewSupplierDialog',
    setSelectedSupplier: SettingsModuleName + '/setSelectedSupplier',
    setSelectedBranchOffice: SettingsModuleName + '/setSelectedBranchOffice',
    addNewBranchOffice: SettingsModuleName + '/addNewBranchOffice',
    removeBranchOffice: SettingsModuleName + '/removeBranchOffice',
    setBranchOffices: SettingsModuleName + '/setBranchOffices',
    addNewBranchOfficeContact: SettingsModuleName + '/addNewBranchOfficeContact',
    setSelectedBranchOfficeContact: SettingsModuleName + '/setSelectedBranchOfficeContact',
    setTermsOfDeliveries: SettingsModuleName + '/setTermsOfDeliveries',
    setTermsOfPayments: SettingsModuleName + '/setTermsOfPayments',
    setLoading: SettingsModuleName + '/setLoading',
    setNetworkError: SettingsModuleName + '/setNetworkError',
    setSelectedBranchOfficeBankAccount: SettingsModuleName + '/setSelectedBranchOfficeBankAccount',
    addNewBranchOfficeBankAccount: SettingsModuleName + '/addNewBranchOfficeBankAccount',
    removeBranchOfficeBankAccount: SettingsModuleName + '/removeBranchOfficeBankAccount',
    setBranchOfficesBankAccounts: SettingsModuleName + '/setBranchOfficesBankAccounts',
    setUnits: SettingsModuleName + '/setUnits',
    setUser: SettingsModuleName + '/setUser',
    setUserFrontendPermissions: SettingsModuleName + '/setUserFrontendPermissions',
    setTranslation: SettingsModuleName + '/setTranslation',
    setCurrencies: SettingsModuleName + '/setCurrencies',
    setDeliveryTimeTypes: SettingsModuleName + 'setDeliveryTimeTypes',
    setExchangeRate: SettingsModuleName + '/setExchangeRate'
  },
  actions: {
    saveSettings: SettingsModuleName + '/saveSettings',
    loadAccount: SettingsModuleName + '/loadAccount',
    loadFrontendPermissions: SettingsModuleName + '/loadFrontendPermissions',
    saveAccount: SettingsModuleName + '/saveAccount',
    openCloseNewSupplierDialog: SettingsModuleName + '/openCloseNewSupplierDialog',
    createSupplier: SettingsModuleName + '/createSupplier',
    removeSupplier: SettingsModuleName + '/removeSupplier',
    loadSuppliers: SettingsModuleName + '/loadSuppliers',
    loadAllSuppliers: SettingsModuleName + '/loadAllSuppliers',
    loadSuppliersByManufacturers: SettingsModuleName + '/loadSuppliersByManufacturers',
    setSelectedSupplier: SettingsModuleName + '/setSelectedSupplier',
    setSelectedBranchOffice: SettingsModuleName + '/setSelectedBranchOffice',
    setBranchOffices: SettingsModuleName + '/setBranchOffices',
    addNewBranchOffice: SettingsModuleName + '/addNewBranchOffice',
    removeBranchOffice: SettingsModuleName + '/removeBranchOffice',
    saveBranchOffices: SettingsModuleName + '/saveBranchOffices',
    loadSupplierBranchOffices: SettingsModuleName + '/loadSupplierBranchOffices',
    loadTermsOfDeliveries: SettingsModuleName + '/loadTermsOfDeliveries',
    loadTermsOfPayments: SettingsModuleName + '/loadTermsOfPayments',
    addNewBranchOfficeContact: SettingsModuleName + '/addNewBranchOfficeContact',
    setSelectedBranchOfficeContact: SettingsModuleName + '/setSelectedBranchOfficeContact',
    clearNetworkError: SettingsModuleName + '/clearNetworkError',
    loadBranchOfficeBankAccounts: SettingsModuleName + '/loadBranchOfficeBankAccounts',
    setSelectedBranchOfficeBankAccount: SettingsModuleName + '/setSelectedBranchOfficeBankAccount',
    addNewBranchOfficeBankAccount: SettingsModuleName + '/addNewBranchOfficeBankAccount',
    removeBranchOfficeBankAccount: SettingsModuleName + '/removeBranchOfficeBankAccount',
    saveBranchOfficeBankAccounts: SettingsModuleName + '/saveBranchOfficeBankAccounts',
    setBranchOfficesBankAccounts: SettingsModuleName + '/setBranchOfficesBankAccounts',
    loadAllUnits: SettingsModuleName + '/loadAllUnits',
    setUnits: SettingsModuleName + '/setUnits',
    translate: SettingsModuleName + '/translate',
    loadAllCurrencies: SettingsModuleName + '/loadAllCurrencies',
    loadAllDeliveryTimeTypes: SettingsModuleName + '/loadAllDeliveryTimeTypes',
    loadExchangeRate: SettingsModuleName + '/loadExchangeRate',
    setExchangeRate: SettingsModuleName + '/setExchangeRate',
    loadAllAccounts: SettingsModuleName + '/loadAllAccounts',
    resetState: SettingsModuleName + '/resetState'

  },
  getters: {
    loading: SettingsModuleName + '/loading',
    getNetworkError: SettingsModuleName + '/getNetworkError',
    getTermsOfPayments: SettingsModuleName + '/getTermsOfPayments',
    getTermsOfDeliveries: SettingsModuleName + '/getTermsOfDeliveries',
    getBranchOfficeContacts: SettingsModuleName + '/getBranchOfficeContacts',
    getSelectedBranchOfficeContact: SettingsModuleName + '/getSelectedBranchOfficeContact',
    getOpenNewSupplierDialogState: SettingsModuleName + '/getOpenNewSupplierDialogState',
    getSupplierBranchOffices: SettingsModuleName + '/getSupplierBranchOffices',
    getSelectedBranchOffice: SettingsModuleName + '/getSelectedBranchOffice',
    getSelectedSupplier: SettingsModuleName + '/getSelectedSupplier',
    getSuppliers: SettingsModuleName + '/getSuppliers',
    getManufacturerSuppliers: SettingsModuleName + '/getManufacturerSuppliers',
    getAllUnits: SettingsModuleName + '/getAllUnits',
    getAccount: SettingsModuleName + '/getAccount',
    getSupplierContacts: SettingsModuleName + '/getSupplierContacts',
    supplierBankAccounts: SettingsModuleName + '/supplierBankAccounts',
    manufacturerTabActive: SettingsModuleName + '/manufacturerTabActive',
    getBranchOfficeBankAccounts: SettingsModuleName + '/getBranchOfficeBankAccounts',
    getSelectedBranchOfficeBankAccount: SettingsModuleName + '/getSelectedBranchOfficeBankAccount',
    getUser: SettingsModuleName + '/getUser',
    getUserFrontendPermissions: SettingsModuleName + '/getUserFrontendPermissions',
    getTranslation: SettingsModuleName + '/getTranslation',
    getAllCurrencies: SettingsModuleName + '/getAllCurrencies',
    getAllDeliveryTimeTypes: SettingsModuleName + '/getAllDeliveryTimeTypes',
    getExchangeRate: SettingsModuleName + '/getExchangeRate',
    getAllSuppliers: SettingsModuleName + '/getAllSuppliers'
  }
}

// private
export const _Settings = removeNamespace(SettingsModuleName, Settings)

// ManufacturerSettings Types
// public
export const ManufacturersSettingsModuleName = 'settingsManufacturers'
export const ManufacturersSettings = {
  mutations: {
    setManufacturers: ManufacturersSettingsModuleName + '/setManufacturers',
    setAllManufacturers: ManufacturersSettingsModuleName + '/setAllManufacturers',
    setSelectedManufacturer: ManufacturersSettingsModuleName + '/setSelectedManufacturer',
    setOpenCloseNewManufacturerDialogState: ManufacturersSettingsModuleName + '/setOpenCloseNewManufacturerDialogState',
    setBranchOfficeHasManufacturers: ManufacturersSettingsModuleName + '/setBranchOfficeHasManufacturers'
  },
  actions: {
    loadManufacturers: ManufacturersSettingsModuleName + '/loadManufacturers',
    loadAllManufacturers: ManufacturersSettingsModuleName + '/loadAllManufacturers',
    saveManufacturers: ManufacturersSettingsModuleName + '/saveManufacturers',
    openCloseNewManufacturerDialog: ManufacturersSettingsModuleName + '/openCloseNewManufacturerDialog',
    setSelectedManufacturer: ManufacturersSettingsModuleName + '/setSelectedManufacturer',
    loadBranchOfficeHasManufacturers: ManufacturersSettingsModuleName + '/loadBranchOfficeHasManufacturers',
    saveBranchOfficeHasManufacturers: ManufacturersSettingsModuleName + '/saveBranchOfficeHasManufacturers',
    resetState: ManufacturersSettingsModuleName + '/resetState'
  },
  getters: {
    manufacturers: ManufacturersSettingsModuleName + '/manufacturers',
    getAllManufacturers: ManufacturersSettingsModuleName + '/getAllManufacturers',
    getOpenNewManufacturerDialogState: ManufacturersSettingsModuleName + '/getOpenNewManufacturerDialogState',
    getSelectedManufacturer: ManufacturersSettingsModuleName + '/getSelectedManufacturer',
    getBranchOfficeHasManufacturers: ManufacturersSettingsModuleName + '/getBranchOfficeHasManufacturers'
  }
}
// private
export const _ManufacturersSettings = removeNamespace(ManufacturersSettingsModuleName, ManufacturersSettings)

// ManufacturerBranchOfficeSettings Types
// public
export const ManufacturerBranchOfficeSettingsModuleName = 'manufacturerBranchOfficesSettings'
export const ManufacturerBranchOfficeSettings = {
  mutations: {
    addNewBranchOffice: ManufacturerBranchOfficeSettingsModuleName + '/addNewBranchOffice',
    removeBranchOffice: ManufacturerBranchOfficeSettingsModuleName + '/removeBranchOffice',
    setBranchOffices: ManufacturerBranchOfficeSettingsModuleName + '/setBranchOffices',
    setSelectedBranchOffice: ManufacturerBranchOfficeSettingsModuleName + '/setSelectedBranchOffice'
  },
  actions: {
    addNewBranchOffice: ManufacturerBranchOfficeSettingsModuleName + '/addNewBranchOffice',
    removeBranchOffice: ManufacturerBranchOfficeSettingsModuleName + '/removeBranchOffice',
    loadBranchOffices: ManufacturerBranchOfficeSettingsModuleName + '/loadBranchOffices',
    saveBranchOffices: ManufacturerBranchOfficeSettingsModuleName + '/saveBranchOffices',
    setSelectedBranchOffice: ManufacturerBranchOfficeSettingsModuleName + '/setSelectedBranchOffice',
    resetManufacturersBranchOffices: ManufacturerBranchOfficeSettingsModuleName + '/resetManufacturersBranchOffices',
    resetState: ManufacturerBranchOfficeSettingsModuleName + '/resetState'
  },
  getters: {
    getBranchOffices: ManufacturerBranchOfficeSettingsModuleName + '/getBranchOffices',
    getSelectedBranchOffice: ManufacturerBranchOfficeSettingsModuleName + '/getSelectedBranchOffice'
  }
}
// private
export const _ManufacturerBranchOfficeSettings = removeNamespace(ManufacturerBranchOfficeSettingsModuleName, ManufacturerBranchOfficeSettings)

// ContactPersonSettings Types
// public
export const ContactPersonSettingsModuleName = 'settingsContactPersons'
export const ContactPersonSettings = {
  mutations: {
    setContactPersons: ContactPersonSettingsModuleName + '/setContactPersons',
    setContactPersonsForSupplier: ContactPersonSettingsModuleName + '/setContactPersonsForSupplier',
    setSelectedContactPerson: ContactPersonSettingsModuleName + '/setSelectedContactPerson',
    removeContactPerson: ContactPersonSettingsModuleName + '/removeContactPerson',
    addNewContactPerson: ContactPersonSettingsModuleName + '/addNewContactPerson',
    setContactPersonHasManufacturers: ContactPersonSettingsModuleName + '/setContactPersonHasManufacturers'
  },
  actions: {
    loadContactPersons: ContactPersonSettingsModuleName + '/loadContactPersons',
    loadContactPersonsBySupplierId: ContactPersonSettingsModuleName + '/loadContactPersonsBySupplierId',
    saveContactPerson: ContactPersonSettingsModuleName + '/saveContactPerson',
    setSelectedContactPerson: ContactPersonSettingsModuleName + '/setSelectedContactPerson',
    setContactPersons: ContactPersonSettingsModuleName + '/setContactPersons',
    removeContactPerson: ContactPersonSettingsModuleName + '/removeContactPerson',
    addNewContactPerson: ContactPersonSettingsModuleName + '/addNewContactPerson',
    loadContactPersonHasManufacturers: ContactPersonSettingsModuleName + '/loadContactPersonHasManufacturers',
    saveSupplierContactHasManufacturers: ContactPersonSettingsModuleName + '/saveSupplierContactHasManufacturers',
    resetState: ContactPersonSettingsModuleName + '/resetState'
  },
  getters: {
    getContactPersons: ContactPersonSettingsModuleName + '/getContactPersons',
    getContactPersonsForSupplierId: ContactPersonSettingsModuleName + '/getContactPersonsForSupplierId',
    getSelectedContactPerson: ContactPersonSettingsModuleName + '/getSelectedContactPerson',
    getContactPersonsHasManufactures: ContactPersonSettingsModuleName + '/getContactPersonsHasManufactures'
  }
}
// private
export const _ContactPersonSettings = removeNamespace(ContactPersonSettingsModuleName, ContactPersonSettings)

// ContactFunctionsSettings Types
// public
export const ContactFunctionsSettingsModuleName = 'settingsContactFunctions'
export const ContactFunctionsSettings = {
  mutations: {
    setContactFunctions: ContactFunctionsSettingsModuleName + '/setContactFunctions',
    setAllContactFunctions: ContactFunctionsSettingsModuleName + '/setAllContactFunctions',
    setSelectedContactFunction: ContactFunctionsSettingsModuleName + '/setSelectedContactFunction',
    setOpenCloseNewContactFunctionDialogState: ContactFunctionsSettingsModuleName + '/setOpenCloseNewContactFunctionDialogState'
  },
  actions: {
    loadContactFunctions: ContactFunctionsSettingsModuleName + '/loadContactFunctions',
    loadAllContactFunctions: ContactFunctionsSettingsModuleName + '/loadAllContactFunctions',
    saveContactFunction: ContactFunctionsSettingsModuleName + '/saveContactFunction',
    openCloseNewContactFunctionDialog: ContactFunctionsSettingsModuleName + '/openCloseNewContactFunctionDialog',
    setSelectedContactFunction: ContactFunctionsSettingsModuleName + '/setSelectedContactFunction',
    resetState: ContactFunctionsSettingsModuleName + '/resetState'
  },
  getters: {
    contactFunctions: ContactFunctionsSettingsModuleName + '/contactFunctions',
    getAllContactFunctions: ContactFunctionsSettingsModuleName + '/getAllContactFunctions',
    getOpenNewContactFunctionDialogState: ContactFunctionsSettingsModuleName + '/getOpenNewContactFunctionDialogState',
    getSelectedContactFunction: ContactFunctionsSettingsModuleName + '/getSelectedContactFunction'
  }
}
// private
export const _ContactFunctionsSettings = removeNamespace(ContactFunctionsSettingsModuleName, ContactFunctionsSettings)

// TermsOfDeliverySettings Types
// public
export const TermsOfDeliverySettingsModuleName = 'settingsTermsOfDeliveries'
export const TermsOfDeliverySettings = {
  mutations: {
    setTermsOfDeliveries: TermsOfDeliverySettingsModuleName + '/setTermsOfDeliveries',
    setAllTermsOfDeliveries: TermsOfDeliverySettingsModuleName + '/setAllTermsOfDeliveries',
    setSelectedTermOfDelivery: TermsOfDeliverySettingsModuleName + '/setSelectedTermOfDelivery',
    setOpenCloseNewDialogState: TermsOfDeliverySettingsModuleName + '/setOpenCloseNewDialogState'
  },
  actions: {
    loadTermsOfDeliveries: TermsOfDeliverySettingsModuleName + '/loadTermsOfDeliveries',
    loadAllTermsOfDeliveries: TermsOfDeliverySettingsModuleName + '/loadAllTermsOfDeliveries',
    saveTermOfDelivery: TermsOfDeliverySettingsModuleName + '/saveTermOfDelivery',
    openCloseNewDialog: TermsOfDeliverySettingsModuleName + '/openCloseNewDialog',
    setSelectedTermOfDelivery: TermsOfDeliverySettingsModuleName + '/setSelectedTermOfDelivery',
    resetState: TermsOfDeliverySettingsModuleName + '/resetState'
  },
  getters: {
    termsOfDeliveries: TermsOfDeliverySettingsModuleName + '/termsOfDeliveries',
    getAllTermsOfDeliveries: TermsOfDeliverySettingsModuleName + '/getAllTermsOfDeliveries',
    getOpenNewDialogState: TermsOfDeliverySettingsModuleName + '/getOpenNewDialogState',
    getSelectedTermOfDelivery: TermsOfDeliverySettingsModuleName + '/getSelectedTermOfDelivery'
  }
}
// private
export const _TermsOfDeliverySettings = removeNamespace(TermsOfDeliverySettingsModuleName, TermsOfDeliverySettings)

// TermsOfPaymentSettings Types
// public
export const TermsOfPaymentSettingsModuleName = 'settingsTermsOfPayments'
export const TermsOfPaymentSettings = {
  mutations: {
    setTermsOfPayments: TermsOfPaymentSettingsModuleName + '/setTermsOfPayments',
    setAllTermsOfPayments: TermsOfPaymentSettingsModuleName + '/setAllTermsOfPayments',
    setSelectedTermOfPayment: TermsOfPaymentSettingsModuleName + '/setSelectedTermOfPayment',
    setOpenCloseNewDialogState: TermsOfPaymentSettingsModuleName + '/setOpenCloseNewDialogState'
  },
  actions: {
    loadTermsOfPayments: TermsOfPaymentSettingsModuleName + '/loadTermsOfPayments',
    loadAllTermsOfPayments: TermsOfPaymentSettingsModuleName + '/loadAllTermsOfPayments',
    saveTermOfPayment: TermsOfPaymentSettingsModuleName + '/saveTermOfPayment',
    openCloseNewDialog: TermsOfPaymentSettingsModuleName + '/openCloseNewDialog',
    setSelectedTermOfPayment: TermsOfPaymentSettingsModuleName + '/setSelectedTermOfPayment',
    resetState: TermsOfPaymentSettingsModuleName + '/resetState'
  },
  getters: {
    termsOfPayments: TermsOfPaymentSettingsModuleName + '/termsOfPayments',
    getAllTermsOfPayments: TermsOfPaymentSettingsModuleName + '/getAllTermsOfPayments',
    getOpenNewDialogState: TermsOfPaymentSettingsModuleName + '/getOpenNewDialogState',
    getSelectedTermOfPayment: TermsOfPaymentSettingsModuleName + '/getSelectedTermOfPayment'
  }
}
// private
export const _TermsOfPaymentSettings = removeNamespace(TermsOfPaymentSettingsModuleName, TermsOfPaymentSettings)

// UsersSettings Types
// public
export const UserSettingsModuleName = 'settingsUser'
export const UserSettings = {
  mutations: {
    setUsers: UserSettingsModuleName + '/setUsers',
    setAllUsers: UserSettingsModuleName + '/setAllUsers',
    setAllUserRoles: UserSettingsModuleName + '/setAllUserRoles',
    setSelectedUser: UserSettingsModuleName + '/setSelectedUser',
    setOpenCloseNewUserDialogState: UserSettingsModuleName + '/setOpenCloseNewUserDialogState'
  },
  actions: {
    loadUsers: UserSettingsModuleName + '/loadUsers',
    loadAllUsers: UserSettingsModuleName + '/loadAllUsers',
    loadAllUserRoles: UserSettingsModuleName + '/loadAllUserRoles',
    saveUser: UserSettingsModuleName + '/saveUser',
    openCloseNewUserDialog: UserSettingsModuleName + '/openCloseNewUserDialog',
    setSelectedUser: UserSettingsModuleName + '/setSelectedUser',
    resetState: UserSettingsModuleName + '/resetState'
  },
  getters: {
    users: UserSettingsModuleName + '/users',
    getAllUsers: UserSettingsModuleName + '/getAllUsers',
    getAllUserRoles: UserSettingsModuleName + '/getAllUserRoles',
    getOpenNewUserDialogState: UserSettingsModuleName + '/getOpenNewUserDialogState',
    getSelectedUser: UserSettingsModuleName + '/getSelectedUser'
  }
}
// private
export const _UsersSettings = removeNamespace(UserSettingsModuleName, UserSettings)

// ProductSettings Types
// public
export const ProductSettingsModuleName = 'settingsProducts'
export const ProductSettings = {
  mutations: {
    setProducts: ProductSettingsModuleName + '/setProducts',
    setAllProducts: ProductSettingsModuleName + '/setAllProducts',
    setSelectedProduct: ProductSettingsModuleName + '/setSelectedProduct',
    setDialogState: ProductSettingsModuleName + '/setDialogState'
  },
  actions: {
    loadProducts: ProductSettingsModuleName + '/loadProducts',
    loadAllProducts: ProductSettingsModuleName + '/loadAllProducts',
    searchProductsByReference: ProductSettingsModuleName + '/searchProductsByReference',
    loadProductByReference: ProductSettingsModuleName + '/loadProductByReference',
    saveProduct: ProductSettingsModuleName + '/saveProduct',
    openCloseDialog: ProductSettingsModuleName + '/openCloseDialog',
    setSelectedProduct: ProductSettingsModuleName + '/setSelectedProduct',
    getProductManufacturer: ProductSettingsModuleName + '/getProductManufacturer',
    saveProductDocument: ProductSettingsModuleName + '/saveProductDocument',
    deleteProductDocument: ProductSettingsModuleName + '/deleteProductDocument',
    updateProductDocumentOrder: ProductSettingsModuleName + '/updateProductDocumentOrder',
    resetState: ProductSettingsModuleName + '/resetState'
  },
  getters: {
    products: ProductSettingsModuleName + '/products',
    loadingProduct: ProductSettingsModuleName + '/loadingProduct',
    getAllProducts: ProductSettingsModuleName + '/getAllProducts',
    getDialogState: ProductSettingsModuleName + '/getDialogState',
    getSelectedProduct: ProductSettingsModuleName + '/getSelectedProduct'
  }
}
// private
export const _ProductSettings = removeNamespace(ProductSettingsModuleName, ProductSettings)

// VatSettings Types
// public
export const VatSettingsModuleName = 'settingsVats'
export const VatSettings = {
  mutations: {
    setVats: VatSettingsModuleName + '/setVats',
    setAllVats: VatSettingsModuleName + '/setAllVats',
    setSelectedVat: VatSettingsModuleName + '/setSelectedVat',
    setDialogState: VatSettingsModuleName + '/setDialogState'
  },
  actions: {
    loadVats: VatSettingsModuleName + '/loadVats',
    loadAllVats: VatSettingsModuleName + '/loadAllVats',
    saveVat: VatSettingsModuleName + '/saveVat',
    openCloseDialog: VatSettingsModuleName + '/openCloseDialog',
    setSelectedVat: VatSettingsModuleName + '/setSelectedVat',
    resetState: VatSettingsModuleName + '/resetState'
  },
  getters: {
    vats: VatSettingsModuleName + '/vats',
    getAllVats: VatSettingsModuleName + '/getAllVats',
    getDialogState: VatSettingsModuleName + '/getDialogState',
    getSelectedVat: VatSettingsModuleName + '/getSelectedVat'
  }
}
// private
export const _VatSettings = removeNamespace(VatSettingsModuleName, VatSettings)

// Customer Types
// public
export const CustomerModuleName = 'customers'
export const Customer = {
  mutations: {
    setCustomers: CustomerModuleName + '/setCustomers',
    setSelectedCustomer: CustomerModuleName + '/setSelectedCustomer',
    setOpenCloseNewCustomerDialogState: CustomerModuleName + '/setOpenCloseNewCustomerDialogState'
  },
  actions: {
    loadCustomers: CustomerModuleName + '/loadCustomers',
    saveCustomers: CustomerModuleName + '/saveCustomers',
    openCloseNewCustomerDialog: CustomerModuleName + '/openCloseNewCustomerDialog',
    setSelectedCustomer: CustomerModuleName + '/setSelectedCustomer',
    resetCustomers: CustomerModuleName + '/resetCustomers',
    resetState: CustomerModuleName + '/resetState'
  },
  getters: {
    customers: CustomerModuleName + '/customers',
    getOpenNewCustomerDialogState: CustomerModuleName + '/getOpenNewCustomerDialogState',
    getSelectedCustomer: CustomerModuleName + '/getSelectedCustomer'
  }
}
// private
export const _Customer = removeNamespace(CustomerModuleName, Customer)

// CustomerBranchOffice Types
// public
export const CustomerBranchOfficeModuleName = 'customerBranchOffices'
export const CustomerBranchOffice = {
  mutations: {
    addNewBranchOffice: CustomerBranchOfficeModuleName + '/addNewBranchOffice',
    removeBranchOffice: CustomerBranchOfficeModuleName + '/removeBranchOffice',
    setBranchOffices: CustomerBranchOfficeModuleName + '/setBranchOffices',
    setSelectedBranchOffice: CustomerBranchOfficeModuleName + '/setSelectedBranchOffice'
  },
  actions: {
    addNewBranchOffice: CustomerBranchOfficeModuleName + '/addNewBranchOffice',
    removeBranchOffice: CustomerBranchOfficeModuleName + '/removeBranchOffice',
    loadCustomerBranchOffices: CustomerBranchOfficeModuleName + '/loadCustomerBranchOffices',
    saveBranchOffices: CustomerBranchOfficeModuleName + '/saveBranchOffices',
    setSelectedBranchOffice: CustomerBranchOfficeModuleName + '/setSelectedBranchOffice',
    resetCustomerBranchOffices: CustomerBranchOfficeModuleName + '/resetCustomerBranchOffices',
    resetState: CustomerBranchOfficeModuleName + '/resetState'
  },
  getters: {
    getCustomerBranchOffices: CustomerBranchOfficeModuleName + '/getCustomerBranchOffices',
    getSelectedBranchOffice: CustomerBranchOfficeModuleName + '/getSelectedBranchOffice'
  }
}
// private
export const _CustomerBranchOffice = removeNamespace(CustomerBranchOfficeModuleName, CustomerBranchOffice)

// CustomerBranchOfficeContact Types
// public
export const CustomerBranchOfficeContactModuleName = 'customerBranchOfficesContact'
export const CustomerBranchOfficeContact = {
  mutations: {
    setContactPersons: CustomerBranchOfficeContactModuleName + '/setContactPersons',
    setSelectedContactPerson: CustomerBranchOfficeContactModuleName + '/setSelectedContactPerson',
    removeContactPerson: CustomerBranchOfficeContactModuleName + '/removeContactPerson',
    addNewContactPerson: CustomerBranchOfficeContactModuleName + '/addNewContactPerson'
  },
  actions: {
    loadContactPersons: CustomerBranchOfficeContactModuleName + '/loadContactPersons',
    saveContactPersons: CustomerBranchOfficeContactModuleName + '/saveContactPerson',
    setSelectedContactPerson: CustomerBranchOfficeContactModuleName + '/setSelectedContactPerson',
    setContactPersons: CustomerBranchOfficeContactModuleName + '/setContactPersons',
    removeContactPerson: CustomerBranchOfficeContactModuleName + '/removeContactPerson',
    addNewContactPerson: CustomerBranchOfficeContactModuleName + '/addNewContactPerson',
    resetState: CustomerBranchOfficeContactModuleName + '/resetState'
  },
  getters: {
    getContactPersons: CustomerBranchOfficeContactModuleName + '/getContactPersons',
    getSelectedContactPerson: CustomerBranchOfficeContactModuleName + '/getSelectedContactPerson'
  }
}
// private
export const _CustomerBranchOfficeContact = removeNamespace(CustomerBranchOfficeContactModuleName, CustomerBranchOfficeContact)

// CustomerBranchOfficeContact Types
// public
export const CustomerBranchOfficeBankAccountsModuleName = 'customerBranchOfficesBankAccounts'
export const CustomerBranchOfficeBankAccounts = {
  mutations: {
    setSelectedBranchOfficeBankAccount: CustomerBranchOfficeBankAccountsModuleName + '/setSelectedBranchOfficeBankAccount',
    addNewBranchOfficeBankAccount: CustomerBranchOfficeBankAccountsModuleName + '/addNewBranchOfficeBankAccount',
    removeBranchOfficeBankAccount: CustomerBranchOfficeBankAccountsModuleName + '/removeBranchOfficeBankAccount',
    setBranchOfficesBankAccounts: CustomerBranchOfficeBankAccountsModuleName + '/setBranchOfficesBankAccounts'
  },
  actions: {
    loadBranchOfficeBankAccounts: CustomerBranchOfficeBankAccountsModuleName + '/loadBranchOfficeBankAccounts',
    setSelectedBranchOfficeBankAccount: CustomerBranchOfficeBankAccountsModuleName + '/setSelectedBranchOfficeBankAccount',
    addNewBranchOfficeBankAccount: CustomerBranchOfficeBankAccountsModuleName + '/addNewBranchOfficeBankAccount',
    removeBranchOfficeBankAccount: CustomerBranchOfficeBankAccountsModuleName + '/removeBranchOfficeBankAccount',
    saveBranchOfficeBankAccounts: CustomerBranchOfficeBankAccountsModuleName + '/saveBranchOfficeBankAccounts',
    setBranchOfficesBankAccounts: CustomerBranchOfficeBankAccountsModuleName + '/setBranchOfficesBankAccounts',
    resetState: CustomerBranchOfficeBankAccountsModuleName + '/resetState'
  },
  getters: {
    getBranchOfficeBankAccounts: CustomerBranchOfficeBankAccountsModuleName + '/getBranchOfficeBankAccounts',
    getSelectedBranchOfficeBankAccount: CustomerBranchOfficeBankAccountsModuleName + '/getSelectedBranchOfficeBankAccount'
  }
}
// private
export const _CustomerBranchOfficeBankAccounts = removeNamespace(CustomerBranchOfficeBankAccountsModuleName, CustomerBranchOfficeBankAccounts)

// Inquiry Types
// public
export const InquiryModuleName = 'inquiries'
export const Inquiry = {
  mutations: {
    setInquiries: InquiryModuleName + '/setInquiries',
    setSelectedInquiry: InquiryModuleName + '/setSelectedInquiry',
    setOpenCloseInquiryDialogState: InquiryModuleName + '/setOpenCloseInquiryDialogState'
  },
  actions: {
    loadInquiries: InquiryModuleName + '/loadInquiries',
    loadInquiryStatus: InquiryModuleName + '/loadInquiryStatus',
    saveInquiries: InquiryModuleName + '/saveInquiries',
    openCloseInquiryDialog: InquiryModuleName + '/openCloseInquiryDialog',
    setSelectedInquiry: InquiryModuleName + '/setSelectedInquiry',
    loadInquiry: InquiryModuleName + '/loadInquiry',
    resetState: InquiryModuleName + '/resetState'
  },
  getters: {
    inquiries: InquiryModuleName + '/inquiries',
    getOpenInquiryDialogState: InquiryModuleName + '/getOpenInquiryDialogState',
    getSelectedInquiry: InquiryModuleName + '/getSelectedInquiry'
  }
}
// private
export const _Inquiry = removeNamespace(InquiryModuleName, Inquiry)

// InquiryPosition Types
// public
export const InquiryPositionModuleName = 'inquiriesPositions'
export const InquiryPosition = {
  mutations: {
    setInquiriesPositions: InquiryPositionModuleName + '/setInquiriesPosition',
    setInquiriesPositionsCopy: InquiryPositionModuleName + '/setInquiriesPositionCopy',
    setAllInquiriesPositions: InquiryPositionModuleName + '/setAllInquiriesPosition',
    setSelectedInquiryPosition: InquiryPositionModuleName + '/setSelectedInquiryPosition',
    updateInquiriesPositionsCopy: InquiryPositionModuleName + '/updateInquiriesPositionsCopy'
  },
  actions: {
    loadInquiriesPositions: InquiryPositionModuleName + '/loadInquiriesPositions',
    loadAllInquiriesPositions: InquiryPositionModuleName + '/loadAllInquiriesPositions',
    saveInquiriesPositions: InquiryPositionModuleName + '/saveInquiriesPositions',
    setSelectedInquiry: InquiryPositionModuleName + '/setSelectedInquiry',
    setSelectedInquiryPosition: InquiryPositionModuleName + '/setSelectedInquiryPosition',
    updateInquiriesPositionsCopy: InquiryPositionModuleName + '/updateInquiriesPositionsCopy',
    deleteInquiriesPositions: InquiryPositionModuleName + '/deleteInquiriesPositions',
    createSupplierRequests: InquiryPositionModuleName + '/createSupplierRequests',
    resetAllInquiriesPositions: InquiryPositionModuleName + '/resetAllInquiriesPositions',
    resetState: InquiryPositionModuleName + '/resetState'
  },
  getters: {
    inquiriesPositions: InquiryPositionModuleName + '/inquiriesPositions',
    inquiriesPositionsCopy: InquiryPositionModuleName + '/inquiriesPositionsCopy',
    allInquiriesPositions: InquiryPositionModuleName + '/allInquiriesPositions',
    getSelectedInquiryPosition: InquiryPositionModuleName + '/getSelectedInquiryPosition'
  }
}
// private
export const _InquiryPosition = removeNamespace(InquiryPositionModuleName, InquiryPosition)

// InquirySupplierRequests Types
// public
export const InquirySupplierRequestsModuleName = 'inquirySupplierRequests'
export const InquirySupplierRequests = {
  mutations: {
    setInquirySupplierRequests: InquirySupplierRequestsModuleName + '/setInquirySupplierRequests',
    setSelectedInquirySupplierRequest: InquirySupplierRequestsModuleName + '/setSelectedInquirySupplierRequest',
    setInquirySupplierRequestsMessage: InquirySupplierRequestsModuleName + '/setInquirySupplierRequestsMessage',
    setOpenCloseInquirySupplierRequestMessageDialogState: InquirySupplierRequestsModuleName + '/setOpenCloseInquirySupplierRequestMessageDialogState',
    setInquirySupplierRequestsDocumentViewTokens: InquirySupplierRequestsModuleName + '/setInquirySupplierRequestsDocumentViewTokens',
    setMessageChanUUID: InquirySupplierRequestsModuleName + '/setMessageChanUUID'
  },
  actions: {
    loadInquirySupplierRequests: InquirySupplierRequestsModuleName + '/loadInquirySupplierRequests',
    loadInquirySupplierRequestsMessage: InquirySupplierRequestsModuleName + '/loadInquirySupplierRequestsMessage',
    setSelectedInquirySupplierRequest: InquirySupplierRequestsModuleName + '/setSelectedInquirySupplierRequest',
    setInquirySupplierRequestsMessage: InquirySupplierRequestsModuleName + '/setInquirySupplierRequestsMessage',
    openCloseInquirySupplierRequestMessageDialog: InquirySupplierRequestsModuleName + '/openCloseInquirySupplierRequestMessageDialog',
    createInquirySupplierRequestsDocumentViewTokens: InquirySupplierRequestsModuleName + '/createInquirySupplierRequestsDocumentViewTokens',
    sendInquirySupplierRequests: InquirySupplierRequestsModuleName + '/sendInquirySupplierRequests',
    setMessageChanUUID: InquirySupplierRequestsModuleName + '/setMessageChanUUID',
    resetState: InquirySupplierRequestsModuleName + '/resetState'

  },
  getters: {
    inquirySupplierRequests: InquirySupplierRequestsModuleName + '/inquirySupplierRequests',
    getSelectedInquirySupplierRequest: InquirySupplierRequestsModuleName + '/getSelectedInquirySupplierRequest',
    getInquirySupplierRequestsMessage: InquirySupplierRequestsModuleName + '/getInquirySupplierRequestsMessage',
    getOpenInquirySupplierRequestMessageDialogState: InquirySupplierRequestsModuleName + '/getOpenInquirySupplierRequestMessageDialogState',
    getInquirySupplierRequestsDocumentViewTokens: InquirySupplierRequestsModuleName + '/getInquirySupplierRequestsDocumentViewTokens',
    getMessageChanUUID: InquirySupplierRequestsModuleName + '/getMessageChanUUID'
  }
}
// private
export const _InquirySupplierRequests = removeNamespace(InquirySupplierRequestsModuleName, InquirySupplierRequests)

// Document Types
// public
export const DocumentsModuleName = 'documents'
export const Documents = {
  mutations: {
    setDocument: DocumentsModuleName + '/setDocument',
    setDocumentUploading: DocumentsModuleName + '/setDocumentUploading',
    setDocumentTokenLoading: DocumentsModuleName + '/setDocumentTokenLoading'
  },
  actions: {
    uploadDocument: DocumentsModuleName + '/uploadDocument',
    getDocumentToken: DocumentsModuleName + '/getDocumentToken',
    resetState: DocumentsModuleName + '/resetState'
  },
  getters: {
    getUploadedDocument: DocumentsModuleName + '/getUploadedDocument',
    documentUploading: DocumentsModuleName + '/documentUploading',
    documentTokenLoading: DocumentsModuleName + '/documentTokenLoading'
  }
}
// private
export const _Documents = removeNamespace(DocumentsModuleName, Documents)

// SupplierOffers Types
// public
export const SupplierOffersModuleName = 'supplierOffers'
export const SupplierOffers = {
  mutations: {
    setSupplierOffer: SupplierOffersModuleName + '/setSupplierOffer',
    setSupplierOfferDocumentViewToken: SupplierOffersModuleName + '/setSupplierOfferDocumentViewToken',
    setLoadSupplierOffer: SupplierOffersModuleName + '/setLoadSupplierOffer',
    setOpenCloseDialogState: SupplierOffersModuleName + '/setOpenCloseDialogState',
    setSelectedSupplierOffer: SupplierOffersModuleName + '/setSelectedSupplierOffer'
  },
  actions: {
    saveSupplierOffer: SupplierOffersModuleName + '/saveSupplierOffer',
    setSupplierOffer: SupplierOffersModuleName + '/setSupplierOffer',
    loadSupplierOfferByInquiryAndSupplierID: SupplierOffersModuleName + '/loadSupplierOfferByInquiryAndSupplierID',
    getDocumentViewTokenBySupplierOfferId: SupplierOffersModuleName + '/getDocumentViewTokenBySupplierOfferId',
    openCloseDialog: SupplierOffersModuleName + '/openCloseDialog',
    setSelectedSupplierOffer: SupplierOffersModuleName + '/setSelectedSupplierOffer',
    resetState: SupplierOffersModuleName + '/resetState'
  },
  getters: {
    getSupplierOffer: SupplierOffersModuleName + '/getSupplierOffer',
    getSelectedSupplierOffer: SupplierOffersModuleName + '/getSelectedSupplierOffer',
    getSupplierOfferDocumentToken: SupplierOffersModuleName + '/getSupplierOfferDocumentToken',
    getLoadingSupplierOffer: SupplierOffersModuleName + '/getLoadingSupplierOffer',
    getOpenDialogState: SupplierOffersModuleName + '/getOpenDialogState'

  }
}
// private
export const _SupplierOffers = removeNamespace(SupplierOffersModuleName, SupplierOffers)

// SupplierOfferDeclines Types
// public
export const SupplierOfferDeclinesModuleName = 'supplierOfferDeclines'
export const SupplierOfferDeclines = {
  mutations: {
    setSupplierOfferDeclines: SupplierOfferDeclinesModuleName + '/setSupplierOfferDeclines',
    setLoadSupplierOfferDeclines: SupplierOfferDeclinesModuleName + '/setLoadSupplierOfferDeclines'
  },
  actions: {
    saveSupplierOfferDeclines: SupplierOfferDeclinesModuleName + '/saveSupplierOfferDeclines',
    setSupplierOfferDeclines: SupplierOfferDeclinesModuleName + '/setSupplierOfferDeclines',
    loadSupplierOfferDeclinesByInquiryID: SupplierOfferDeclinesModuleName + '/loadSupplierOfferDeclinesByInquiryID',
    removeSupplierOfferDecline: SupplierOfferDeclinesModuleName + '/removeSupplierOfferDecline',
    resetState: SupplierOfferDeclinesModuleName + '/resetState'
  },
  getters: {
    getSupplierOfferDeclines: SupplierOfferDeclinesModuleName + '/getSupplierOfferDeclines',
    getLoadingSupplierOfferDeclines: SupplierOfferDeclinesModuleName + '/getLoadingSupplierOfferDeclines'
  }
}
// private
export const _SupplierOfferDeclines = removeNamespace(SupplierOfferDeclinesModuleName, SupplierOfferDeclines)

// SupplierOfferPositionDeclines Types
// public
export const SupplierOfferPositionDeclinesModuleName = 'supplierOfferPositionDeclines'
export const SupplierOfferPositionDeclines = {
  mutations: {
    setSupplierOfferPositionDeclines: SupplierOfferPositionDeclinesModuleName + '/setSupplierOfferPositionDeclines',
    setLoadSupplierOfferPositionDeclines: SupplierOfferPositionDeclinesModuleName + '/setLoadSupplierOfferPositionDeclines'
  },
  actions: {
    saveSupplierOfferPositionDeclines: SupplierOfferPositionDeclinesModuleName + '/saveSupplierOfferPositionDeclines',
    setSupplierOfferPositionDeclines: SupplierOfferPositionDeclinesModuleName + '/setSupplierOfferPositionDeclines',
    loadSupplierOfferPositionDeclinesByInquiryPositionID: SupplierOfferPositionDeclinesModuleName + '/loadSupplierOfferPositionDeclinesByInquiryPositionID',
    removeSupplierOfferPositionDecline: SupplierOfferPositionDeclinesModuleName + '/removeSupplierOfferPositionDecline',
    resetState: SupplierOfferPositionDeclinesModuleName + '/resetState'
  },
  getters: {
    getSupplierOfferPositionDeclines: SupplierOfferPositionDeclinesModuleName + '/getSupplierOfferPositionDeclines',
    getLoadingSupplierOfferPositionDeclines: SupplierOfferPositionDeclinesModuleName + '/getLoadingSupplierOfferPositionDeclines'
  }
}
// private
export const _SupplierOfferPositionDeclines = removeNamespace(SupplierOfferPositionDeclinesModuleName, SupplierOfferPositionDeclines)

// SupplierOfferPositions Types
// public
export const SupplierOfferPositionModuleName = 'supplierOfferPositions'
export const SupplierOfferPositions = {
  mutations: {
    setSupplierOfferPosition: SupplierOfferPositionModuleName + '/setSupplierOfferPosition',
    setSelectedSupplierOfferPosition: SupplierOfferPositionModuleName + '/setSelectedSupplierOfferPosition',
    setSupplierOfferPositions: SupplierOfferPositionModuleName + '/setSupplierOfferPositions',
    setSupplierOfferPositionsBySupplierOffer: SupplierOfferPositionModuleName + '/setSupplierOfferPositionsBySupplierOffer',
    setSupplierOfferPositionPrice: SupplierOfferPositionModuleName + '/setSupplierOfferPositionPrice',
    setLoadSupplierOfferPosition: SupplierOfferPositionModuleName + '/setLoadSupplierOfferPosition',
    setRemovingSupplierOfferPosition: SupplierOfferPositionModuleName + '/setRemovingSupplierOfferPosition',
    setSavingSupplierOfferPosition: SupplierOfferPositionModuleName + '/setSavingSupplierOfferPosition',
    setOpenCloseDialogState: SupplierOfferPositionModuleName + '/setOpenCloseDialogState'
  },
  actions: {
    saveSupplierOfferPosition: SupplierOfferPositionModuleName + '/saveSupplierOfferPosition',
    setSupplierOfferPosition: SupplierOfferPositionModuleName + '/setSupplierOfferPosition',
    setSelectedSupplierOfferPosition: SupplierOfferPositionModuleName + '/setSelectedSupplierOfferPosition',
    setSupplierOfferPositionPrice: SupplierOfferPositionModuleName + '/setSupplierOfferPositionPrice',
    loadSupplierOfferPositionBySupplierOfferAndInquiryPositionID: SupplierOfferPositionModuleName + '/loadSupplierOfferPositionBySupplierOfferAndInquiryPositionID',
    loadSupplierOfferPositionByProductID: SupplierOfferPositionModuleName + '/loadSupplierOfferPositionByProductID',
    loadSupplierOfferPositionByProductIDIndex: SupplierOfferPositionModuleName + '/loadSupplierOfferPositionByProductIDIndex',
    loadSupplierOfferPositionsBySupplierOffer: SupplierOfferPositionModuleName + '/loadSupplierOfferPositionsBySupplierOffer',
    removeSupplierOfferPositionDiscount: SupplierOfferPositionModuleName + '/removeSupplierOfferPositionDiscount',
    openCloseDialog: SupplierOfferPositionModuleName + '/openCloseDialog',
    deleteSupplierOfferPosition: SupplierOfferPositionModuleName + '/deleteSupplierOfferPosition',
    resetState: SupplierOfferPositionModuleName + '/resetState',
    getProductsWithPrices: SupplierOfferPositionModuleName + '/getProductsWithPrices'
  },
  getters: {
    getSupplierOfferPosition: SupplierOfferPositionModuleName + '/getSupplierOfferPosition',
    getSelectedSupplierOfferPosition: SupplierOfferPositionModuleName + '/getSelectedSupplierOfferPosition',
    getSupplierOfferPositions: SupplierOfferPositionModuleName + '/getSupplierOfferPositions',
    getSupplierOfferPositionsBySupplierOffer: SupplierOfferPositionModuleName + '/getSupplierOfferPositionsBySupplierOffer',
    getLoadingSupplierOfferPosition: SupplierOfferPositionModuleName + '/getLoadingSupplierOfferPosition',
    getSupplierOfferPositionPrice: SupplierOfferPositionModuleName + '/getSupplierOfferPositionPrice',
    getRemovingSupplierOfferPositionDiscount: SupplierOfferPositionModuleName + '/getRemovingSupplierOfferPositionDiscount',
    getSavingSupplierOfferPosition: SupplierOfferPositionModuleName + '/getSavingSupplierOfferPosition',
    getOpenDialogState: SupplierOfferPositionModuleName + '/getOpenDialogState'
  }
}
// private
export const _SupplierOfferPositions = removeNamespace(SupplierOfferPositionModuleName, SupplierOfferPositions)

// Offers Types
// public
export const OfferModuleName = 'offers'
export const Offer = {
  mutations: {
    setOffers: OfferModuleName + '/setOffers',
    setUnconfirmedOffers: OfferModuleName + '/setUnconfirmedOffers',
    setSelectedOffer: OfferModuleName + '/setSelectedOffer',
    setOpenCloseDialogState: OfferModuleName + '/setOpenCloseDialogState',
    setCreatingOfferForInquiry: OfferModuleName + '/setCreatingOfferForInquiry',
    setCustomerOfferDocumentViewToken: OfferModuleName + 'setCustomerOfferDocumentViewToken'
  },
  actions: {
    loadOffers: OfferModuleName + '/loadOffers',
    loadUnconfirmedOffers: OfferModuleName + '/loadUnconfirmedOffers',
    loadStatuses: OfferModuleName + '/loadStatuses',
    loadFollowUpStatuses: OfferModuleName + '/loadFollowUpStatuses',
    saveOffer: OfferModuleName + '/saveOffer',
    createForInquiry: OfferModuleName + '/createForInquiry',
    openCloseDialog: OfferModuleName + '/openCloseDialog',
    setSelectedOffer: OfferModuleName + '/setSelectedOffer',
    createCustomerOfferMessage: OfferModuleName + '/createCustomerOfferMessage',
    getDocumentViewTokenByCustomerOfferId: OfferModuleName + '/getDocumentViewTokenByCustomerOfferId',
    sendOfferMessage: OfferModuleName + '/sendOfferMessage',
    reloadSelectedCustomerOffer: OfferModuleName + '/reloadSelectedCustomerOffer',
    resetState: OfferModuleName + '/resetState'

  },
  getters: {
    offers: OfferModuleName + '/offers',
    unconfirmedOffers: OfferModuleName + '/unconfirmedOffers',
    getOpenDialogState: OfferModuleName + '/getOpenDialogState',
    getSelectedOffer: OfferModuleName + '/getSelectedOffer',
    getCreatingOfferForInquiry: OfferModuleName + '/getCreatingOfferForInquiry',
    getCustomerOfferDocumentViewToken: OfferModuleName + '/getCustomerOfferDocumentViewToken'
  }
}
// private
export const _Offer = removeNamespace(OfferModuleName, Offer)

// OfferPosition Types
// public
export const OfferPositionModuleName = 'offersPositions'
export const OfferPosition = {
  mutations: {
    setOffersPositions: OfferPositionModuleName + '/setOffersPositions',
    setSelectedOfferPosition: OfferPositionModuleName + '/setSelectedOfferPosition',
    setOpenCloseDialogState: OfferPositionModuleName + '/setOpenCloseDialogState',
    setOpenCloseCalculateDialogState: OfferPositionModuleName + '/setOpenCloseCalculateDialogState',
    setRemovingOfferPositionDiscount: OfferPositionModuleName + '/setRemovingOfferPositionDiscount',
    setRemovingOfferPositionCommission: OfferPositionModuleName + '/setRemovingOfferPositionCommission',
    setRemovingOfferPositionAddCosts: OfferPositionModuleName + '/setRemovingOfferPositionAddCosts'
  },
  actions: {
    loadOffersPositions: OfferPositionModuleName + '/loadOffersPositions',
    saveOfferPosition: OfferPositionModuleName + '/saveOfferPosition',
    saveOfferPositions: OfferPositionModuleName + '/saveOfferPositions',
    openCloseDialog: OfferPositionModuleName + '/openCloseDialog',
    openCloseCalculateDialog: OfferPositionModuleName + '/openCloseCalculateDialog',
    setSelectedOfferPosition: OfferPositionModuleName + '/setSelectedOfferPosition',
    resetOffersPositions: OfferPositionModuleName + '/resetOffersPositions',
    removeOfferPositionDiscount: OfferPositionModuleName + '/removeOfferPositionDiscount',
    removeOfferPositionCommission: OfferPositionModuleName + '/removeOfferPositionCommission',
    removeOfferPositionAddCosts: OfferPositionModuleName + '/removeOfferPositionAddCosts',
    resetState: OfferPositionModuleName + '/resetState'
  },
  getters: {
    offersPositions: OfferPositionModuleName + '/offersPositions',
    getOpenDialogState: OfferPositionModuleName + '/getOpenDialogState',
    getOpenCalculateDialogState: OfferPositionModuleName + '/getOpenCalculateDialogState',
    getSelectedOfferPosition: OfferPositionModuleName + '/getSelectedOfferPosition',
    getRemovingOfferPositionDiscount: OfferPositionModuleName + '/getRemovingOfferPositionDiscount',
    getRemovingOfferPositionCommission: OfferPositionModuleName + '/getRemovingOfferPositionCommission',
    getRemovingOfferPositionAddCosts: OfferPositionModuleName + '/getRemovingOfferPositionAddCosts'
  }
}
// private
export const _OfferPosition = removeNamespace(OfferPositionModuleName, OfferPosition)

// Dashboard Types
// public
export const DashboardModuleName = 'dashboard'
export const Dashboard = {
  mutations: {
    setWeeklyInquiriesStat: DashboardModuleName + '/setWeeklyInquiriesStat'
  },
  actions: {
    loadWeeklyInquiresStats: DashboardModuleName + '/loadWeeklyInquiresStats'
  },
  getters: {
    getWeeklyInquiriesStat: DashboardModuleName + '/getWeeklyInquiriesStat'
  }
}
// private
export const _Dashboard = removeNamespace(DashboardModuleName, Dashboard)

// PurchaseOrder Types
// public
export const PurchaseOrderModuleName = 'purchaseOrder'
export const PurchaseOrder = {
  mutations: {
    setPurchaseOrders: PurchaseOrderModuleName + '/setPurchaseOrders',
    setUnconfirmedOfferPositions: PurchaseOrderModuleName + '/setUnconfirmedOfferPositions',
    setSelectedPurchaseOrder: PurchaseOrderModuleName + '/setSelectedPurchaseOrder',
    setOpenCloseDialogState: PurchaseOrderModuleName + '/setOpenCloseDialogState',
    setCreatingPurchaseOrderMessage: PurchaseOrderModuleName + '/setCreatingPurchaseOrderMessage',
    setPurchaseOrderDocumentViewToken: PurchaseOrderModuleName + '/setPurchaseOrderDocumentViewToken',
    setCreatingPurchaseOfferPositions: PurchaseOrderModuleName + '/setCreatingPurchaseOfferPositions'
  },
  actions: {
    loadPurchaseOrders: PurchaseOrderModuleName + '/loadPurchaseOrders',
    loadUnconfirmedOfferPositions: PurchaseOrderModuleName + '/loadUnconfirmedOfferPositions',
    loadStatuses: PurchaseOrderModuleName + '/loadStatuses',
    loadCustomerOffers: PurchaseOrderModuleName + '/loadCustomerOffers',
    savePurchaseOrder: PurchaseOrderModuleName + '/savePurchaseOrder',
    openCloseDialog: PurchaseOrderModuleName + '/openCloseDialog',
    setSelectedPurchaseOrder: PurchaseOrderModuleName + '/setSelectedPurchaseOrder',
    createPurchaseOrderMessage: PurchaseOrderModuleName + '/createPurchaseOrderMessage',
    getDocumentViewTokenByPurchaseOrderId: PurchaseOrderModuleName + '/getDocumentViewTokenByPurchaseOrderId',
    reloadSelectedPurchaseOrder: PurchaseOrderModuleName + '/reloadSelectedPurchaseOrder',
    createOrderPositions: PurchaseOrderModuleName + '/createOrderPositions',
    createProcurement: PurchaseOrderModuleName + '/createProcurement',
    loadPurchaseOrderById: PurchaseOrderModuleName + '/loadPurchaseOrderById',
    resetState: PurchaseOrderModuleName + '/resetState',
    sendOrderConfirmation: PurchaseOrderModuleName + '/sendOrderConfirmation'
  },
  getters: {
    purchaseOrders: PurchaseOrderModuleName + '/purchaseOrders',
    unconfirmedOfferPositions: PurchaseOrderModuleName + '/unconfirmedOfferPositions',
    getOpenDialogState: PurchaseOrderModuleName + '/getOpenDialogState',
    getSelectedPurchaseOrder: PurchaseOrderModuleName + '/getSelectedPurchaseOrder',
    getCreatingPurchaseOrderMessage: PurchaseOrderModuleName + '/getCreatingPurchaseOrderMessage',
    getPurchaseOrderDocumentViewToken: PurchaseOrderModuleName + '/getPurchaseOrderDocumentViewToken',
    creatingPurchaseOrderPositions: PurchaseOrderModuleName + '/creatingPurchaseOrderPositions'
  }
}
// private
export const _PurchaseOrder = removeNamespace(PurchaseOrderModuleName, PurchaseOrder)

// PurchaseOrderPosition Types
// public
export const PurchaseOrderPositionModuleName = 'purchaseOrderPositions'
export const PurchaseOrderPosition = {
  mutations: {
    setPurchaseOrderPositions: PurchaseOrderPositionModuleName + '/setPurchaseOrderPositions',
    setSelectedPurchaseOrderPosition: PurchaseOrderPositionModuleName + '/setSelectedPurchaseOrderPosition',
    setOpenCloseDialogState: PurchaseOrderPositionModuleName + '/setOpenCloseDialogState'
  },
  actions: {
    loadPurchaseOrderPositions: PurchaseOrderPositionModuleName + '/loadPurchaseOrderPositions',
    loadStatuses: PurchaseOrderPositionModuleName + '/loadStatuses',
    savePurchaseOrderPosition: PurchaseOrderPositionModuleName + '/savePurchaseOrderPosition',
    openCloseDialog: PurchaseOrderPositionModuleName + '/openCloseDialog',
    setSelectedPurchaseOrderPosition: PurchaseOrderPositionModuleName + '/setSelectedPurchaseOrderPosition',
    reloadSelectedPurchaseOrderPosition: PurchaseOrderPositionModuleName + '/reloadSelectedPurchaseOrderPosition',
    deleteOrderPositions: PurchaseOrderPositionModuleName + '/deleteOrderPositions',
    getReadyForInvoicePositions: PurchaseOrderPositionModuleName + '/getReadyForInvoicePositions',
    resetState: PurchaseOrderPositionModuleName + '/resetState'
  },
  getters: {
    purchaseOrderPositions: PurchaseOrderPositionModuleName + '/purchaseOrderPositions',
    getOpenDialogState: PurchaseOrderPositionModuleName + '/getOpenDialogState',
    getSelectedPurchaseOrderPosition: PurchaseOrderPositionModuleName + '/getSelectedPurchaseOrderPosition'
  }
}
// private
export const _PurchaseOrderPosition = removeNamespace(PurchaseOrderPositionModuleName, PurchaseOrderPosition)

// Procurement Types
// public
export const ProcurementModuleName = 'procurements'
export const Procurement = {
  mutations: {
    setProcurements: ProcurementModuleName + '/setProcurements',
    setSelectedProcurement: ProcurementModuleName + '/setSelectedProcurement',
    setOpenCloseDialogState: ProcurementModuleName + '/setOpenCloseDialogState',
    setCreatingSupplierOrders: PurchaseOrderModuleName + '/setCreatingSupplierOrders'
  },
  actions: {
    loadProcurements: ProcurementModuleName + '/loadProcurements',
    loadProcurement: ProcurementModuleName + '/loadProcurement',
    loadStatuses: ProcurementModuleName + '/loadStatuses',
    saveProcurement: ProcurementModuleName + '/saveProcurement',
    openCloseDialog: ProcurementModuleName + '/openCloseDialog',
    setSelectedProcurement: ProcurementModuleName + '/setSelectedProcurement',
    reloadSelectedProcurement: ProcurementModuleName + '/reloadSelectedProcurement',
    createSupplierOrders: ProcurementModuleName + '/createSupplierOrders',
    resetState: ProcurementModuleName + '/resetState'
  },
  getters: {
    procurements: ProcurementModuleName + '/procurements',
    getOpenDialogState: ProcurementModuleName + '/getOpenDialogState',
    getSelectedProcurement: ProcurementModuleName + '/getSelectedProcurement',
    creatingProcurementPositions: ProcurementModuleName + '/creatingProcurementPositions',
    creatingSupplierOrders: ProcurementModuleName + '/creatingSupplierOrders'
  }
}
// private
export const _Procurement = removeNamespace(ProcurementModuleName, Procurement)

// ProcurementPosition Types
// public
export const ProcurementPositionModuleName = 'procurementPositions'
export const ProcurementPosition = {
  mutations: {
    setProcurementPositions: ProcurementPositionModuleName + '/setProcurementPositions',
    setSelectedProcurementPosition: ProcurementPositionModuleName + '/setSelectedProcurementPosition',
    setOpenCloseDialogState: ProcurementPositionModuleName + '/setOpenCloseDialogState'
  },
  actions: {
    loadProcurementPositions: ProcurementPositionModuleName + '/loadProcurementPositions',
    loadStatuses: ProcurementPositionModuleName + '/loadStatuses',
    saveProcurementPosition: ProcurementPositionModuleName + '/saveProcurementPosition',
    confirmProcurementPosition: ProcurementPositionModuleName + '/confirmProcurementPosition',
    openCloseDialog: ProcurementPositionModuleName + '/openCloseDialog',
    setSelectedProcurementPosition: ProcurementPositionModuleName + '/setSelectedProcurementPosition',
    reloadSelectedProcurementPosition: ProcurementPositionModuleName + '/reloadSelectedProcurementPosition',
    resetState: ProcurementPositionModuleName + '/resetState'
  },
  getters: {
    procurementPositions: ProcurementPositionModuleName + '/procurementPositions',
    getOpenDialogState: ProcurementPositionModuleName + '/getOpenDialogState',
    getSelectedProcurementPosition: ProcurementPositionModuleName + '/getSelectedProcurementPosition'
  }
}
// private
export const _ProcurementPosition = removeNamespace(ProcurementPositionModuleName, ProcurementPosition)

// History Types
// public
export const HistoryModuleName = 'histories'
export const History = {
  mutations: {
    setHistories: HistoryModuleName + '/setHistories'
  },
  actions: {
    loadHistories: HistoryModuleName + '/loadHistories',
    saveHistory: HistoryModuleName + '/saveHistory',
    resetState: HistoryModuleName + '/resetState'
  },
  getters: {
    histories: HistoryModuleName + '/histories'
  }
}
// private
export const _History = removeNamespace(HistoryModuleName, History)

// SupplierOrder Types
// public
export const SupplierOrderModuleName = 'supplierOrder'
export const SupplierOrder = {
  mutations: {
    setSupplierOrders: SupplierOrderModuleName + '/setSupplierOrders',
    setSelectedSupplierOrder: SupplierOrderModuleName + '/setSelectedSupplierOrder',
    setOpenCloseDialogState: SupplierOrderModuleName + '/setOpenCloseDialogState'
  },
  actions: {
    loadSupplierOrderById: SupplierOrderModuleName + '/loadSupplierOrderById',
    loadSupplierOrders: SupplierOrderModuleName + '/loadSupplierOrders',
    loadSupplierOrdersForProcurement: SupplierOrderModuleName + '/loadSupplierOrdersForProcurement',
    loadStatuses: SupplierOrderModuleName + '/loadStatuses',
    saveSupplierOrder: SupplierOrderModuleName + '/saveSupplierOrder',
    confirmSupplierOrder: SupplierOrderModuleName + '/confirmSupplierOrder',
    openCloseDialog: SupplierOrderModuleName + '/openCloseDialog',
    setSelectedSupplierOrder: SupplierOrderModuleName + '/setSelectedSupplierOrder',
    sendSupplierOrder: SupplierOrderModuleName + '/sendSupplierOrder',
    deleteSupplierOrder: SupplierOrderModuleName + '/deleteSupplierOrder',
    resetState: SupplierOrderModuleName + '/resetState'
  },
  getters: {
    supplierOrders: SupplierOrderModuleName + '/supplierOrders',
    getOpenDialogState: SupplierOrderModuleName + '/getOpenDialogState',
    getSelectedSupplierOrder: SupplierOrderModuleName + '/getSelectedSupplierOrder'
  }
}
// private
export const _SupplierOrder = removeNamespace(SupplierOrderModuleName, SupplierOrder)

// SupplierOrderPosition Types
// public
export const SupplierOrderPositionModuleName = 'supplierOrderPositions'
export const SupplierOrderPosition = {
  mutations: {
    setSupplierOrderPositions: SupplierOrderPositionModuleName + '/setSupplierOrderPositions',
    setSelectedSupplierOrderPosition: SupplierOrderPositionModuleName + '/setSelectedSupplierOrderPosition',
    setOpenCloseDialogState: SupplierOrderPositionModuleName + '/setOpenCloseDialogState',
    setRemovingSupplierOrderPosition: SupplierOrderPositionModuleName + '/setRemovingSupplierOrderPosition'

  },
  actions: {
    loadSupplierOrderPositionsForSupplierOrder: SupplierOrderPositionModuleName + '/loadSupplierOrderPositionsForSupplierOrder',
    loadStatuses: SupplierOrderPositionModuleName + '/loadStatuses',
    saveSupplierOrderPosition: SupplierOrderPositionModuleName + '/saveSupplierOrderPosition',
    openCloseDialog: SupplierOrderPositionModuleName + '/openCloseDialog',
    setSelectedSupplierOrderPosition: SupplierOrderPositionModuleName + '/setSelectedSupplierOrderPosition',
    reloadSelectedSupplierOrderPosition: SupplierOrderPositionModuleName + '/reloadSelectedSupplierOrderPosition',
    deleteSupplierOrderPosition: SupplierOrderPositionModuleName + '/deleteSupplierOrderPosition',
    setRemovingSupplierOrderPosition: SupplierOrderPositionModuleName + '/setRemovingSupplierOrderPosition',
    resetState: SupplierOrderPositionModuleName + '/resetState'
  },
  getters: {
    supplierOrderPositions: SupplierOrderPositionModuleName + '/supplierOrderPositions',
    getOpenDialogState: SupplierOrderPositionModuleName + '/getOpenDialogState',
    getSelectedSupplierOrderPosition: SupplierOrderPositionModuleName + '/getSelectedSupplierOrderPosition'
  }
}
// private
export const _SupplierOrderPosition = removeNamespace(SupplierOrderPositionModuleName, SupplierOrderPosition)

// SupplierOrderProforma Types
// public
export const SupplierOrderProformaModuleName = 'supplierOrderProforma'
export const SupplierOrderProforma = {
  mutations: {
    setSupplierOrderProformas: SupplierOrderProformaModuleName + '/setSupplierOrderProformas',
    setSelectedSupplierOrderProforma: SupplierOrderProformaModuleName + '/setSelectedSupplierOrderProforma'
  },
  actions: {
    loadSupplierOrderProformas: SupplierOrderProformaModuleName + '/loadSupplierOrderProformas',
    loadSupplierOrdersProforma: SupplierOrderProformaModuleName + '/loadSupplierOrdersProforma',
    loadStatuses: SupplierOrderProformaModuleName + '/loadStatuses',
    saveSupplierOrderProforma: SupplierOrderProformaModuleName + '/saveSupplierOrderProforma',
    setSelectedSupplierOrderProforma: SupplierOrderProformaModuleName + '/setSelectedSupplierOrderProforma',
    deleteSupplierOrderProforma: SupplierOrderProformaModuleName + '/deleteSupplierOrderProforma',
    resetState: SupplierOrderProformaModuleName + '/resetState'
  },
  getters: {
    supplierOrderProformas: SupplierOrderProformaModuleName + '/supplierOrderProformas',
    getSelectedSupplierOrderProforma: SupplierOrderProformaModuleName + '/getSelectedSupplierOrder'
  }
}
// private
export const _SupplierOrderProforma = removeNamespace(SupplierOrderProformaModuleName, SupplierOrderProforma)

// FollowUp Types
// public
export const FollowUpModuleName = 'followUp'
export const FollowUp = {
  mutations: {
    setFollowUps: FollowUpModuleName + '/setFollowUps'
  },
  actions: {
    loadFollowUps: FollowUpModuleName + '/loadFollowUps',
    resetState: FollowUpModuleName + '/resetState'
  },
  getters: {
    followUps: FollowUpModuleName + '/followUps'
  }
}
// private
export const _FollowUp = removeNamespace(FollowUpModuleName, FollowUp)

// Invoice Types
// public
export const InvoiceModuleName = 'invoice'
export const Invoice = {
  mutations: {
    setInvoices: InvoiceModuleName + '/setInvoices',
    setSelectedInvoice: InvoiceModuleName + '/setSelectedInvoice',
    setOpenCloseDialogState: InvoiceModuleName + '/setOpenCloseDialogState'
  },
  actions: {
    loadInvoices: InvoiceModuleName + '/loadInvoices',
    loadInvoiceById: InvoiceModuleName + '/loadInvoiceById',
    loadStatuses: InvoiceModuleName + '/loadStatuses',
    loadInvoiceTypes: InvoiceModuleName + '/loadInvoiceTypes',
    saveInvoice: InvoiceModuleName + '/saveInvoice',
    confirmInvoice: InvoiceModuleName + '/confirmInvoice',
    openCloseDialog: InvoiceModuleName + '/openCloseDialog',
    setSelectedInvoice: InvoiceModuleName + '/setSelectedInvoice',
    sendInvoice: InvoiceModuleName + '/sendInvoice',
    deleteInvoice: InvoiceModuleName + '/deleteInvoice',
    startPicking: InvoiceModuleName + '/startPicking',
    createInvoice: InvoiceModuleName + '/createInvoice',
    createFreeInvoice: InvoiceModuleName + '/createFreeInvoice',
    reloadSelectedInvoice: InvoiceModuleName + '/reloadSelectedInvoice',
    resetState: InvoiceModuleName + '/resetState'
  },
  getters: {
    invoices: InvoiceModuleName + '/invoices',
    getOpenDialogState: InvoiceModuleName + '/getOpenDialogState',
    getSelectedInvoice: InvoiceModuleName + '/getSelectedInvoice'
  }
}
// private
export const _Invoice = removeNamespace(InvoiceModuleName, Invoice)

// InvoicePosition Types
// public
export const InvoicePositionModuleName = 'invoicePositions'
export const InvoicePosition = {
  mutations: {
    setInvoicePositions: InvoicePositionModuleName + '/setInvoicePositions',
    setSelectedInvoicePosition: InvoicePositionModuleName + '/setSelectedInvoicePosition',
    setOpenCloseDialogState: InvoicePositionModuleName + '/setOpenCloseDialogState',
    setRemovingInvoicePosition: InvoicePositionModuleName + '/setRemovingInvoicePosition'

  },
  actions: {
    loadInvoicePositionForInvoice: InvoicePositionModuleName + '/loadInvoicePositionForInvoice',
    loadStatuses: InvoicePositionModuleName + '/loadStatuses',
    saveInvoicePosition: InvoicePositionModuleName + '/saveInvoicePosition',
    openCloseDialog: InvoicePositionModuleName + '/openCloseDialog',
    setSelectedInvoicePosition: InvoicePositionModuleName + '/setSelectedInvoicePosition',
    reloadSelectedInvoicePosition: InvoicePositionModuleName + '/reloadSelectedInvoicePosition',
    deleteInvoicePosition: InvoicePositionModuleName + '/deleteInvoicePosition',
    setRemovingInvoicePosition: InvoicePositionModuleName + '/setRemovingInvoicePosition',
    confirmInvoicePosition: InvoicePositionModuleName + '/confirmInvoicePosition',
    clearInvoicePositions: InvoicePositionModuleName + '/clearInvoicePositions',
    resetState: InvoicePositionModuleName + '/resetState'
  },
  getters: {
    invoicePositions: InvoicePositionModuleName + '/invoicePositions',
    getOpenDialogState: InvoicePositionModuleName + '/getOpenDialogState',
    getSelectedInvoicePosition: InvoicePositionModuleName + '/getSelectedInvoicePosition'
  }
}
// private
export const _InvoicePosition = removeNamespace(InvoicePositionModuleName, InvoicePosition)

// SupplierOrderPositionReceived Types
// public
export const SupplierOrderPositionReceivedModuleName = 'supplierOrderPositionReceived'
export const SupplierOrderPositionReceived = {
  mutations: {
    setSupplierOrderPositionsReceived: SupplierOrderPositionReceivedModuleName + '/setSupplierOrderPositionsReceived',
    setSelectedSupplierOrderPositionReceived: SupplierOrderPositionReceivedModuleName + '/setSelectedSupplierOrderPositionReceived',
    setOpenCloseDialogState: SupplierOrderPositionReceivedModuleName + '/setOpenCloseDialogState',
    setRemovingSupplierOrderPositionReceived: SupplierOrderPositionReceivedModuleName + '/setRemovingSupplierOrderPositionReceived'

  },
  actions: {
    loadSupplierOrderPositionReceivedForPosition: SupplierOrderPositionReceivedModuleName + '/loadSupplierOrderPositionReceivedForPosition',
    loadStatuses: SupplierOrderPositionReceivedModuleName + '/loadStatuses',
    saveSupplierOrderPositionReceived: SupplierOrderPositionReceivedModuleName + '/saveSupplierOrderPositionReceived',
    saveSupplierOrderPositionReceivedClaim: SupplierOrderPositionReceivedModuleName + '/saveSupplierOrderPositionReceivedClaim',
    openCloseDialog: SupplierOrderPositionReceivedModuleName + '/openCloseDialog',
    setSelectedSupplierOrderPositionReceived: SupplierOrderPositionReceivedModuleName + '/setSelectedSupplierOrderPositionReceived',
    deleteSupplierOrderPositionReceived: SupplierOrderPositionReceivedModuleName + '/deleteSupplierOrderPositionReceived',
    setRemovingSupplierOrderPositionReceived: SupplierOrderPositionReceivedModuleName + '/setRemovingSupplierOrderPositionReceived',
    resetState: SupplierOrderPositionReceivedModuleName + '/resetState'
  },
  getters: {
    supplierOrderPositionsReceived: SupplierOrderPositionReceivedModuleName + '/supplierOrderPositionsReceived',
    getOpenDialogState: SupplierOrderPositionReceivedModuleName + '/getOpenDialogState',
    getSelectedSupplierOrderPositionReceived: SupplierOrderPositionReceivedModuleName + '/getSelectedSupplierOrderPositionReceived'
  }
}
// private
export const _SupplierOrderPositionReceived = removeNamespace(SupplierOrderPositionReceivedModuleName, SupplierOrderPositionReceived)

// Picking Types
// public
export const PickingModuleName = 'picking'
export const Picking = {
  mutations: {
    setPickings: PickingModuleName + '/setPickings',
    setSelectedPicking: PickingModuleName + '/setSelectedPicking',
    setOpenCloseDialogState: PickingModuleName + '/setOpenCloseDialogState'
  },
  actions: {
    loadPickingsForInvoiceId: PickingModuleName + '/loadPickingsForInvoiceId',
    reloadPicking: PickingModuleName + '/reloadPicking',
    finishPicking: PickingModuleName + '/finishPicking',
    loadStatuses: PickingModuleName + '/loadStatuses',
    loadPackageTypes: PickingModuleName + '/loadPackageTypes',
    savePicking: PickingModuleName + '/savePicking',
    openCloseDialog: PickingModuleName + '/openCloseDialog',
    setSelectedPicking: PickingModuleName + '/setSelectedPicking',
    deletePicking: PickingModuleName + '/deletePicking',
    createPickingList: PickingModuleName + '/createPickingList',
    clearPickings: PickingModuleName + '/clearPickings',
    resetState: PickingModuleName + '/resetState'
  },
  getters: {
    pickings: PickingModuleName + '/pickings',
    getOpenDialogState: PickingModuleName + '/getOpenDialogState',
    getSelectedPicking: PickingModuleName + '/getSelectedPicking'
  }
}
// private
export const _Picking = removeNamespace(PickingModuleName, Picking)

// PickingPosition Types
// public
export const PickingPositionModuleName = 'pickingPositions'
export const PickingPosition = {
  mutations: {
    setPickingPositions: PickingPositionModuleName + '/setPickingPositions',
    setSelectedPickingPosition: PickingPositionModuleName + '/setSelectedPickingPosition',
    setOpenCloseDialogState: PickingPositionModuleName + '/setOpenCloseDialogState',
    setRemovingPickingPosition: PickingPositionModuleName + '/setRemovingPickingPosition'

  },
  actions: {
    loadPickingPositionForPicking: PickingPositionModuleName + '/loadPickingPositionForPicking',
    loadStatuses: PickingPositionModuleName + '/loadStatuses',
    savePickingPosition: PickingPositionModuleName + '/savePickingPosition',
    openCloseDialog: PickingPositionModuleName + '/openCloseDialog',
    setSelectedPickingPosition: PickingPositionModuleName + '/setSelectedPickingPosition',
    reloadSelectedPickingPosition: PickingPositionModuleName + '/reloadSelectedPickingPosition',
    deletePickingPosition: PickingPositionModuleName + '/deletePickingPosition',
    setRemovingPickingPosition: PickingPositionModuleName + '/setRemovingPickingPosition',
    clearPickingPositions: PickingPositionModuleName + '/clearPickingPositions',
    resetState: PickingPositionModuleName + '/resetState'
  },
  getters: {
    pickingPositions: PickingPositionModuleName + '/pickingPositions',
    getOpenDialogState: PickingPositionModuleName + '/getOpenDialogState',
    getSelectedPickingPosition: PickingPositionModuleName + '/getSelectedPickingPosition'
  }
}
// private
export const _PickingPosition = removeNamespace(PickingPositionModuleName, PickingPosition)

// BrandConfiguration Types
// public
export const BrandConfigurationModuleName = 'brandConfigurations'
export const BrandConfiguration = {
  mutations: {
    setBrandConfigurations: BrandConfigurationModuleName + '/setBrandConfigurations',
    setAllBrandConfigurations: BrandConfigurationModuleName + '/setAllBrandConfigurations',
    setSelectedBrandConfiguration: BrandConfigurationModuleName + '/setSelectedBrandConfiguration',
    setOpenCloseDialogState: BrandConfigurationModuleName + '/setOpenCloseDialogState'
  },
  actions: {
    loadBrandConfigurations: BrandConfigurationModuleName + '/loadBrandConfigurations',
    loadAllBrandConfigurations: BrandConfigurationModuleName + '/loadAllBrandConfigurations',
    saveBrandConfiguration: BrandConfigurationModuleName + '/saveBrandConfiguration',
    openCloseDialog: BrandConfigurationModuleName + '/openCloseDialog',
    setSelectedBrandConfiguration: BrandConfigurationModuleName + '/setSelectedBrandConfiguration',
    resetState: BrandConfigurationModuleName + '/resetState'
  },
  getters: {
    brandConfigurations: BrandConfigurationModuleName + '/brandConfigurations',
    getAllBrandConfigurations: BrandConfigurationModuleName + '/getAllBrandConfigurations',
    getOpenDialogState: BrandConfigurationModuleName + '/getOpenDialogState',
    getSelectedBrandConfiguration: BrandConfigurationModuleName + '/getSelectedBrandConfiguration'
  }
}
// private
export const _BrandConfiguration = removeNamespace(BrandConfigurationModuleName, BrandConfiguration)

// BrandConfiguration Types
// public
export const BrandConfigurationCIModuleName = 'brandConfigurationsCI'
export const BrandConfigurationCI = {
  mutations: {
    setBrandConfigurationCIs: BrandConfigurationCIModuleName + '/setBrandConfigurationCIs',
    setAllBrandConfigurationCIs: BrandConfigurationCIModuleName + '/setAllBrandConfigurationCIs',
    setSelectedBrandConfigurationCI: BrandConfigurationCIModuleName + '/setSelectedBrandConfigurationCI',
    setOpenCloseDialogState: BrandConfigurationCIModuleName + '/setOpenCloseDialogState',
    addNewCI: BrandConfigurationCIModuleName + '/addNewCI',
    removeCI: BrandConfigurationCIModuleName + '/removeCI',
    setDefaultCI: BrandConfigurationCIModuleName + '/setDefaultCI'
  },
  actions: {
    loadBrandConfigurationCIs: BrandConfigurationCIModuleName + '/loadBrandConfigurationCIs',
    loadAllBrandConfigurationCIs: BrandConfigurationCIModuleName + '/loadAllBrandConfigurationCIs',
    saveBrandConfigurationCI: BrandConfigurationCIModuleName + '/saveBrandConfigurationCI',
    openCloseDialog: BrandConfigurationCIModuleName + '/openCloseDialog',
    setSelectedBrandConfigurationCI: BrandConfigurationCIModuleName + '/setSelectedBrandConfigurationCI',
    resetState: BrandConfigurationCIModuleName + '/resetState',
    addNewCI: BrandConfigurationCIModuleName + '/addNewCI',
    removeCI: BrandConfigurationCIModuleName + '/removeCI'
  },
  getters: {
    brandConfigurationCIs: BrandConfigurationCIModuleName + '/brandConfigurationCIs',
    getAllBrandConfigurationCIs: BrandConfigurationCIModuleName + '/getAllBrandConfigurationCIs',
    getOpenDialogState: BrandConfigurationCIModuleName + '/getOpenDialogState',
    getSelectedBrandConfigurationCI: BrandConfigurationCIModuleName + '/getSelectedBrandConfigurationCI',
    defaultCI: BrandConfigurationCIModuleName + '/defaultCI'
  }
}
// private
export const _BrandConfigurationCI = removeNamespace(BrandConfigurationCIModuleName, BrandConfigurationCI)

// BrandConfigurationBranchOffices Types
// public
export const BrandConfigurationBranchOfficesModuleName = 'brandConfigurationsBranchOffice'
export const BrandConfigurationBranchOffice = {
  mutations: {
    setBrandConfigurationBranchOffices: BrandConfigurationBranchOfficesModuleName + '/setBrandConfigurationBranchOffices',
    setAllBrandConfigurationBranchOffices: BrandConfigurationBranchOfficesModuleName + '/setAllBrandConfigurationBranchOffices',
    setSelectedBrandConfigurationBranchOffice: BrandConfigurationBranchOfficesModuleName + '/setSelectedBrandConfigurationBranchOffice',
    setOpenCloseDialogState: BrandConfigurationBranchOfficesModuleName + '/setOpenCloseDialogState',
    addNewBranchOffice: BrandConfigurationBranchOfficesModuleName + '/addNewBranchOffice',
    addNewBankAccountToBrandConfiguration: BrandConfigurationBranchOfficesModuleName + '/addNewBankAccountToBrandConfiguration',
    removeBranchOffice: BrandConfigurationBranchOfficesModuleName + '/removeBranchOffice',
    removeBranchOfficeBankAccountFromBrandConfiguration: BrandConfigurationBranchOfficesModuleName + '/removeBranchOfficeBankAccountFromBrandConfiguration',
    setAllBankAccountsOfBranchOffice: BrandConfigurationBranchOfficesModuleName + '/setAllBankAccountsOfBranchOffice',


  },
  actions: {
    saveOrUpdateAdditionalBankAccount: BrandConfigurationBranchOfficesModuleName + '/saveOrUpdateAdditionalBankAccount',
    loadBrandConfigurationBranchOffices: BrandConfigurationBranchOfficesModuleName + '/loadBrandConfigurationBranchOffices',
    loadAllBrandConfigurationBranchOffices: BrandConfigurationBranchOfficesModuleName + '/loadAllBrandConfigurationBranchOffices',
    loadAllBrandConfigurationBranchOfficesBankAccounts: BrandConfigurationBranchOfficesModuleName + '/loadAllBrandConfigurationBranchOfficesBankAccounts',
    saveBrandConfigurationBranchOffice: BrandConfigurationBranchOfficesModuleName + '/saveBrandConfigurationBranchOffice',
    // openCloseDialog: BrandConfigurationBranchOfficesModuleNam + '/openCloseDialog',
    setSelectedBrandConfigurationBranchOffice: BrandConfigurationBranchOfficesModuleName + '/setSelectedBrandConfigurationBranchOffice',
    resetState: BrandConfigurationBranchOfficesModuleName + '/resetState',
    addNewBranchOffice: BrandConfigurationBranchOfficesModuleName + '/addNewBranchOffice',
    addNewBankAccountToBrandConfiguration: BrandConfigurationBranchOfficesModuleName + '/addNewBankAccountToBrandConfiguration',
    removeBranchOffice: BrandConfigurationBranchOfficesModuleName + '/removeBranchOffice',
    removeBranchOfficeBankAccountFromBrandConfiguration: BrandConfigurationBranchOfficesModuleName + '/removeBranchOfficeBankAccountFromBrandConfiguration'

  },
  getters: {
    brandConfigurationBranchOffices: BrandConfigurationBranchOfficesModuleName + '/brandConfigurationBranchOffices',
    getAllBrandConfigurationBranchOffices: BrandConfigurationBranchOfficesModuleName + '/getAllBrandConfigurationBranchOffices',
    getOpenDialogState: BrandConfigurationBranchOfficesModuleName + '/getOpenDialogState',
    getAllBrandConfigurationBranchOfficesBankAccounts: BrandConfigurationBranchOfficesModuleName + '/getAllBrandConfigurationBranchOfficesBankAccounts',
    getSelectedBrandConfigurationBranchOffice: BrandConfigurationBranchOfficesModuleName + '/getSelectedBrandConfigurationBranchOffice'
  }
}
// private
export const _BrandConfigurationBranchOffice = removeNamespace(BrandConfigurationBranchOfficesModuleName, BrandConfigurationBranchOffice)

// BrandConfigurationMailSettings Types
// public
export const BrandConfigurationMailSettingsModuleName = 'brandConfigurationsMailSettings'
export const BrandConfigurationMailSetting = {
  mutations: {
    setBrandConfigurationMailSettings: BrandConfigurationMailSettingsModuleName + '/setBrandConfigurationMailSettings',
    setAllBrandConfigurationMailSettings: BrandConfigurationMailSettingsModuleName + '/setAllBrandConfigurationMailSettings',
    setSelectedBrandConfigurationMailSettings: BrandConfigurationMailSettingsModuleName + '/setSelectedBrandConfigurationMailSettings',
    setOpenCloseDialogState: BrandConfigurationMailSettingsModuleName + '/setOpenCloseDialogState',
    addNewItem: BrandConfigurationMailSettingsModuleName + '/addNewItem',
    removeItem: BrandConfigurationMailSettingsModuleName + '/removeItem'
  },
  actions: {
    loadBrandConfigurationMailSettings: BrandConfigurationMailSettingsModuleName + '/loadBrandConfigurationMailSettings',
    loadAllBrandConfigurationMailSettings: BrandConfigurationMailSettingsModuleName + '/loadAllBrandConfigurationMailSettings',
    saveBrandConfigurationMailSettings: BrandConfigurationMailSettingsModuleName + '/saveBrandConfigurationMailSettings',
    openCloseDialog: BrandConfigurationMailSettingsModuleName + '/openCloseDialog',
    setSelectedBrandConfigurationMailSettings: BrandConfigurationMailSettingsModuleName + '/setSelectedBrandConfigurationMailSettings',
    resetState: BrandConfigurationMailSettingsModuleName + '/resetState',
    addNewItem: BrandConfigurationMailSettingsModuleName + '/addNewItem',
    removeItem: BrandConfigurationMailSettingsModuleName + '/removeItem'
  },
  getters: {
    brandConfigurationMailSettings: BrandConfigurationMailSettingsModuleName + '/brandConfigurationMailSettings',
    getAllBrandConfigurationMailSettings: BrandConfigurationMailSettingsModuleName + '/getAllBrandConfigurationMailSettings',
    getOpenDialogState: BrandConfigurationMailSettingsModuleName + '/getOpenDialogState',
    getSelectedBrandConfigurationMailSettings: BrandConfigurationMailSettingsModuleName + '/getSelectedBrandConfigurationMailSettings'
  }
}
// private
export const _BrandConfigurationMailSetting = removeNamespace(BrandConfigurationMailSettingsModuleName, BrandConfigurationMailSetting)

// CashFlow Types
// public
export const GoggleAdWordsModuleName = 'googleAdWords'
export const GoogleAdWords = {
  mutations: {
    uploadProductState: GoggleAdWordsModuleName + '/'
  },
  actions: {
    getSuggestionsForProduct: GoggleAdWordsModuleName + '/getSuggestionsForProduct'
  },
  getters: {
    getServerResponse: GoggleAdWordsModuleName + '/'
  }

}
// private
export const _GoogleAdWords = removeNamespace(GoggleAdWordsModuleName, GoogleAdWords)

// CashFlow Types
// public
export const CashFlowModuleName = 'cashFlow'
export const CashFlow = {
  mutations: {
    setCashFlows: CashFlowModuleName + '/setCashFlows'
  },
  actions: {
    loadCashFlows: CashFlowModuleName + '/loadCashFlows',
    resetState: CashFlowModuleName + '/resetState'
  },
  getters: {
    cashFlow: CashFlowModuleName + '/cashFlow'
  }
}
// private
export const _CashFlow = removeNamespace(CashFlowModuleName, CashFlow)

// ProductListings Types
// public
export const ProductListingsModuleName = 'productListings'
export const ProductListings = {
  mutations: {
    setDialogState: ProductListingsModuleName + '/setDialogState',
    setCalculationDialogState: ProductListingsModuleName + '/setCalculationDialogState',
    setPriceCalculations: ProductListingsModuleName + '/setPriceCalculations',
    setSelectedPriceCalculation: ProductListingsModuleName + '/setSelectedPriceCalculation'
  },
  actions: {
    setDialogState: ProductListingsModuleName + '/setDialogState',
    openCloseDialog: ProductListingsModuleName + '/openCloseDialog',
    openClosePriceCalculationDialog: ProductListingsModuleName + '/openClosePriceCalculationDialog',
    saveProduct: ProductListingsModuleName + '/saveProduct',
    deleteProduct: ProductListingsModuleName + '/deleteProduct',
    loadProduct: ProductListingsModuleName + '/loadProduct',
    loadPriceCalculations: ProductListingsModuleName + '/loadPriceCalculations',
    savePriceCalculation: ProductListingsModuleName + '/savePriceCalculation',
    setSelectedPriceCalculation: ProductListingsModuleName + '/setSelectedPriceCalculation',
    createProductSyncJob: ProductListingsModuleName + '/createProductSyncJob',
    updateProductSyncJob: ProductListingsModuleName + '/updateProductSyncJob',
    loadRunningSyncJob: ProductListingsModuleName + '/loadRunningSyncJob',
    setActiveCalculationState: ProductListingsModuleName + '/setActiveCalculationState',
    removeDiscount: ProductListingsModuleName + '/removeDiscount',
    removeAddCost: ProductListingsModuleName + '/removeAddCost',
    resetState: ProductListingsModuleName + '/resetState'
  },
  getters: {
    products: ProductListingsModuleName + '/products',
    priceCalculations: ProductListingsModuleName + '/priceCalculations',
    loadingProduct: ProductListingsModuleName + '/loadingProduct',
    getDialogState: ProductListingsModuleName + '/getDialogState',
    getCalculationDialogState: ProductListingsModuleName + '/getCalculationDialogState',
    getSelectedProduct: ProductListingsModuleName + '/getSelectedProduct',
    getSelectedPriceCalculation: ProductListingsModuleName + '/getSelectedPriceCalculation'
  }
}
// private
export const _ProductListings = removeNamespace(ProductListingsModuleName, ProductListings)

// BrandConfigurationShopifySettings Types
// public
export const BrandConfigurationShopifySettingsModuleName = 'brandConfigurationsShopifySettings'
export const BrandConfigurationShopifySettings = {
  mutations: {
    setBrandConfigurationShopifySettings: BrandConfigurationShopifySettingsModuleName + '/setBrandConfigurationShopifySettings',
    setAllBrandConfigurationShopifySettings: BrandConfigurationShopifySettingsModuleName + '/setAllBrandConfigurationShopifySettings',
    setSelectedBrandConfigurationShopifySettings: BrandConfigurationShopifySettingsModuleName + '/setSelectedBrandConfigurationShopifySettings',
    setOpenCloseDialogState: BrandConfigurationShopifySettingsModuleName + '/setOpenCloseDialogState',
    addNewItem: BrandConfigurationShopifySettingsModuleName + '/addNewItem',
    removeItem: BrandConfigurationShopifySettingsModuleName + '/removeItem'
  },
  actions: {
    loadBrandConfigurationShopifySettings: BrandConfigurationShopifySettingsModuleName + '/loadBrandConfigurationShopifySettings',
    loadAllBrandConfigurationShopifySettings: BrandConfigurationShopifySettingsModuleName + '/loadAllBrandConfigurationShopifySettings',
    saveBrandConfigurationShopifySettings: BrandConfigurationShopifySettingsModuleName + '/saveBrandConfigurationShopifySettings',
    openCloseDialog: BrandConfigurationShopifySettingsModuleName + '/openCloseDialog',
    setSelectedBrandConfigurationShopifySettings: BrandConfigurationShopifySettingsModuleName + '/setSelectedBrandConfigurationShopifySettings',
    resetState: BrandConfigurationShopifySettingsModuleName + '/resetState',
    addNewItem: BrandConfigurationShopifySettingsModuleName + '/addNewItem',
    removeItem: BrandConfigurationShopifySettingsModuleName + '/removeItem'
  },
  getters: {
    brandConfigurationShopifySettings: BrandConfigurationShopifySettingsModuleName + '/brandConfigurationShopifySettings',
    getAllBrandConfigurationShopifySettings: BrandConfigurationShopifySettingsModuleName + '/getAllBrandConfigurationShopifySettings',
    getOpenDialogState: BrandConfigurationShopifySettingsModuleName + '/getOpenDialogState',
    getSelectedBrandConfigurationShopifySettings: BrandConfigurationShopifySettingsModuleName + '/getSelectedBrandConfigurationShopifySettings'
  }
}
// private
export const _BrandConfigurationShopifySettings = removeNamespace(BrandConfigurationShopifySettingsModuleName, BrandConfigurationShopifySettings)

// removeNamespace Helper Function
export default function removeNamespace (namespace, types) {
  return _.reduce(types, (typeObj, typeValue, typeName) => {
    typeObj[typeName] = _.reduce(typeValue, (obj, v, k) => {
      obj[k] = v.replace(namespace + '/', '')
      return obj
    }, {})
    return typeObj
  }, {})
}



// WEBPACK FOOTER //
// ./src/store/namespace-helper.js